import React from "react";

// Google Forms の「送信」→「リンク」で表示される URL
const GOOGLE_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLSfg-4eJAp4fypKioRKGl-yd_8GRYLEQA_KIDnXs-dZS5OEfrQ/viewform";

export default function Contacts(): JSX.Element {
  return (
    <div className="mb-5">
      <p>
        お問い合わせは下記のフォームよりお願いいたします。
        <br />
        Please contact us using the form below.
      </p>
      <a
        href={GOOGLE_FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary"
      >
        お問い合わせフォーム / Contact Form
      </a>
    </div>
  );
}
